// import ReferenceInput from 'component/ReferenceInput.html'

const code_k = 75

export default mediator => {
	// window.addEventHandler('keydown', event => {

	// })
}
